'use client';
import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';

const sections = [
  {
    number: '1',
    title: 'Sobre a Plataforma',
    content: [
      'A 1 dia de cada vez é uma plataforma online criada com o objetivo de oferecer conteúdo, apoio e informação para pessoas que desejam parar ou reduzir o vício em jogos online, apostas e cassinos.',
      'A utilização da plataforma implica na aceitação integral destes Termos de Uso.',
      'Caso o usuário não concorde com qualquer parte destes termos, recomenda-se que não utilize a plataforma.',
    ],
  },
  {
    number: '2',
    title: 'Natureza da Plataforma',
    content: [
      'A plataforma 1 dia de cada vez tem caráter educativo, informativo e comunitário.',
      'Os conteúdos disponibilizados não substituem acompanhamento médico, psicológico ou terapêutico profissional.',
      'Usuários que enfrentam problemas graves relacionados ao vício são incentivados a procurar ajuda profissional especializada.',
    ],
  },
  {
    number: '3',
    title: 'Uso da Plataforma',
    content: [
      'Ao utilizar a plataforma, o usuário concorda em utilizar o site de forma ética e legal, não praticar atividades ilícitas, não utilizar o espaço para assédio, discriminação ou ataques a outros usuários, e não divulgar conteúdos ilegais ou ofensivos.',
      'A administração da plataforma poderá remover conteúdos ou restringir acesso caso essas regras sejam violadas.',
    ],
  },
  {
    number: '4',
    title: 'Conteúdos da Plataforma',
    content: [
      'Todos os textos, materiais e conteúdos publicados na 1 dia de cada vez possuem finalidade educativa e de apoio.',
      'A reprodução de conteúdo pode ser permitida desde que seja citada a fonte e não seja utilizada para fins comerciais sem autorização.',
    ],
  },
  {
    number: '5',
    title: 'Doações',
    content: [
      'A plataforma 1 dia de cada vez é gratuita e sempre será.',
      'Para manter o projeto ativo e em constante evolução, podem ser aceitas doações voluntárias de usuários ou apoiadores.',
      'As doações são voluntárias, não geram qualquer tipo de benefício exclusivo ou obrigação da plataforma, e não são reembolsáveis, salvo em casos previstos em lei.',
    ],
  },
  {
    number: '6',
    title: 'Limitação de Responsabilidade',
    content: [
      'A plataforma não garante resultados específicos relacionados à recuperação do vício em apostas.',
      'Cada processo de recuperação é individual e depende de diversos fatores pessoais.',
      'A 1 dia de cada vez não se responsabiliza por decisões tomadas pelos usuários com base nos conteúdos disponibilizados.',
    ],
  },
  {
    number: '7',
    title: 'Modificações dos Termos',
    content: [
      'A plataforma poderá atualizar estes Termos de Uso a qualquer momento para melhorar a experiência do usuário ou adequar-se à legislação.',
      'Recomenda-se a revisão periódica desta página.',
    ],
  },
  {
    number: '8',
    title: 'Contato',
    content: [
      'Para dúvidas ou solicitações relacionadas aos Termos de Uso, entre em contato através do e-mail:',
    ],
    email: 'lutecontraovicio@gmail.com',
  },
];

export default function TermosDeUsoPage() {
  const [scrollY, setScrollY] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden" style={{ backgroundColor: '#1A1A2E', color: '#F8F7F4' }}>
      {/* NAV */}
      <nav
        className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-4 transition-all duration-300"
        style={{
          backgroundColor: scrollY > 40 ? 'rgba(26,26,46,0.95)' : 'transparent',
          backdropFilter: scrollY > 40 ? 'blur(12px)' : 'none',
          borderBottom: scrollY > 40 ? '1px solid rgba(196,168,130,0.15)' : 'none',
        }}
      >
        <Link href="/">
          <Image
            src="/assets/images/logo_1dia_transparente-1777268210110.png"
            alt="1 Dia de Cada Vez"
            width={120}
            height={40}
            className="object-contain"
            style={{ maxHeight: '38px' }}
          />
        </Link>
        <Link
          href="/sign-up-login"
          className="px-5 py-2 rounded-xl text-sm font-semibold transition-all duration-200 hover:scale-105"
          style={{ backgroundColor: '#7C9E87', color: '#fff' }}
        >
          Quero Sair Disso
        </Link>
      </nav>
      {/* Background blobs */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full opacity-10 blur-3xl"
          style={{ backgroundColor: '#7C9E87' }}
        />
        <div
          className="absolute bottom-1/3 right-1/4 w-80 h-80 rounded-full opacity-8 blur-3xl"
          style={{ backgroundColor: '#C4A882' }}
        />
      </div>
      {/* Content */}
      <main
        className="relative z-10 max-w-2xl mx-auto px-6 pt-32 pb-24"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(24px)',
          transition: 'opacity 0.6s cubic-bezier(0.22,1,0.36,1), transform 0.6s cubic-bezier(0.22,1,0.36,1)',
        }}
      >
        {/* Header */}
        <div className="mb-12">
          <span
            className="inline-block text-xs font-semibold tracking-widest uppercase mb-4 px-3 py-1 rounded-full"
            style={{ backgroundColor: 'rgba(124,158,135,0.15)', color: '#7C9E87' }}
          >
            Plataforma 1 dia de cada vez
          </span>
          <h1
            className="text-4xl md:text-5xl font-bold leading-tight mb-3"
            style={{ color: '#F8F7F4' }}
          >
            Termos de Uso
          </h1>
          <p className="text-sm mb-4" style={{ color: 'rgba(248,247,244,0.45)' }}>
            Última atualização: Abril de 2026
          </p>
          <div className="w-16 h-1 rounded-full" style={{ backgroundColor: '#C4A882' }} />
        </div>

        {/* Sections */}
        <div className="space-y-10">
          {sections?.map((section) => (
            <div key={section?.number}>
              <div className="flex items-center gap-3 mb-4">
                <span
                  className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold"
                  style={{ backgroundColor: 'rgba(124,158,135,0.2)', color: '#7C9E87' }}
                >
                  {section?.number}
                </span>
                <h2 className="text-lg font-semibold" style={{ color: '#F8F7F4' }}>
                  {section?.title}
                </h2>
              </div>
              <div className="pl-10 space-y-3">
                {section?.content?.map((para, i) => (
                  <p
                    key={i}
                    className="text-base leading-relaxed"
                    style={{ color: 'rgba(248,247,244,0.78)' }}
                  >
                    {para}
                  </p>
                ))}
                {section?.email && (
                  <a
                    href={`mailto:${section?.email}`}
                    className="inline-block text-sm font-medium transition-opacity hover:opacity-80"
                    style={{ color: '#7C9E87' }}
                  >
                    {section?.email}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Footer links */}
        <div
          className="mt-14 pt-8 flex flex-wrap gap-4 justify-center"
          style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}
        >
          {[
            { href: '/', label: '← Início' },
            { href: '/quem-somos', label: 'Quem Somos' },
            { href: '/politica-de-privacidade', label: 'Política de Privacidade' },
            { href: '/seja-voluntario', label: 'Contato' },
          ]?.map((link) => (
            <Link
              key={link?.href}
              href={link?.href}
              className="text-sm transition-opacity hover:opacity-80"
              style={{ color: 'rgba(248,247,244,0.4)' }}
            >
              {link?.label}
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
